<template>
  <div class="basic">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div style="display: flex">
        <div class="left-basic">
          {{ ruleForm.name }}
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          {{ ruleForm.sex }}
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          {{ ruleForm.birthday }}
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.birthday"
              style="width: 100%"
              value-format="timestamp"
            ></el-date-picker>
          </el-form-item>
          {{ ruleForm.phone }}
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          {{ ruleForm.place }}
          <el-form-item label="籍贯" prop="place">
            <el-input v-model="ruleForm.place"></el-input>
          </el-form-item>
          <!-- <el-form-item label="活动区域" prop="region">
          <el-select v-model="ruleForm.region" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        </div>
        <div class="right-basic">
          <el-form-item
            label="照片"
            prop="imageUrl"
            style="margin-bottom: 42px"
          >
            <el-upload
              class="avatar-uploader"
              action="#"
              accept="image/*"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onChangeImg"
            >
              <img v-if="imageUrl" :src="ruleForm.imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="annotations">
             请上传jpg/png格式的尺寸为300：400的蓝底照片
            </div>
          </el-form-item>
          {{ ruleForm.outlook }}
          <el-form-item label="政治面貌" prop="outlook">
            <el-select
              v-model="ruleForm.outlook"
              placeholder="请选择活动区域"
              style="width: 100%"
            >
              <el-option label="区域一" value="1"></el-option>
              <el-option label="区域二" value="2"></el-option>
            </el-select>
          </el-form-item>
          {{ ruleForm.belonging }}
          <el-form-item label="所属检察院" prop="belonging">
            <el-input v-model="ruleForm.belonging"></el-input>
          </el-form-item>
        </div>
      </div>
      {{ ruleForm.tinymceHtml }}
      <el-form-item label="个人简介" prop="tinymceHtml">
        <ueditor
          v-if="editorShow"
          :baseValue="ruleForm.tinymceHtml"
          id="tinymce"
          ref="tinymce"
          :init="editorInit"
        ></ueditor>

      </el-form-item>
      <el-button
        type="primary"
        ref="rongyu"
        @click="submitForm('ruleForm')"
        style="display: none"
        >立即创建</el-button
      >
    </el-form>
  </div>
</template>

<script>
import ueditor from "@/components/editor";
export default {
  components: { ueditor },
  data() {
    return {
      imageUrl: false,
      editorShow: true,
      editorInit: {
        language_url: "/static/tinymce/zh_CN.js",
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/lightgray",
        height: 300,
      },

      ruleForm: {
        name: "",
        sex: "1",
        birthday: "",
        phone: "",
        place: "",
        imageUrl: "123",
        outlook: "", //面貌
        belonging: "", //所属
        tinymceHtml: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请选输入手机号", trigger: "blur" }],
        place: [{ required: true, message: "请选输入籍贯", trigger: "blur" }],
        imageUrl: [{ required: true, message: "请上传照片", trigger: "blur" }],
        outlook: [{ required: true, message: "请选择面貌", trigger: "blur" }],
        belonging: [
          { required: true, message: "请选择所属检察院", trigger: "blur" },
        ],
        tinymceHtml: [
          { required: true, message: "请输入个人简介", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 平台logo上传
    onChangeImg(file) {
      this.imageUrl = true;
      this.uploadImgToOss(file)
        .then((res) => {
          this.imageUrl = true;
          console.log(res);
          if (res.data.code == 200) {
            this.ruleForm.imageUrl = res.data.data.networkurl;
            // console.log(this.logo);
            // this.getPlatformConfigList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    submitForm(formName) {
      // console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.$emit("basicList", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    subClick() {
      this.ruleForm.tinymceHtml = this.$refs.tinymce.myValue;
      this.$refs.rongyu.$el.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.basic {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border: 1px solid #e4e7ed;
  padding: 20px 20px;

  .left-basic {
    width: 40%;
  }
  .right-basic {
    width: 40%;
  }
}
/deep/.el-input__inner {
  height: 36px;
  width: 80%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 83px;
  height: 83px;
  line-height: 83px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 83px;
  height: 83px;
  display: block;
}
.annotations {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
/deep/.el-input__suffix {
  right: 20%;
}
/deep/.el-form-item {
  margin-bottom: 15px;
}
#tinymce {
  width: 80%;
}
</style>